import React from 'react'
import { Container, Content, Section, Subtitle } from 'bloomer'

import CallsToAction from './ctas'

const GetStarted = ({ title, description, style }) => (
  <Section
    isSize={'small'}
    style={{
      background: 'rgba(243, 245, 247, 1)',
      position: 'relative',
      ...style
    }}
  >
    <Container hasTextAlign={'centered'} style={{ marginBottom: '2rem' }}>
      <Subtitle hasTextAlign={'centered'} isSize={2} style={{ fontWeight: '700' }}>
        {title || `Win More Business With Route Today`}
      </Subtitle>
      <Content isSize={'medium'}>
        {description ||
          `Bring the best out of your growth with powerful software built for
        service companies, and the help of our customer success team.`}
      </Content>
      <CallsToAction className={'get-started-cta__container'} columns />
    </Container>
  </Section>
)

export default GetStarted
